/*
 * PROD-7828 R10 — GET /policy/rules: the active policy rows, grouped by the server. Read-only; the
 * route takes no fields (requestFieldsExempt, like /additional/categories).
 */
import { get_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';
import { envelope_data } from '../format';

export const fetch_policy_rules = () =>
  get_api(get_api_url('/v2/cms_user/teacher_payments/policy/rules'), true).then(envelope_data);
